import { RegexValidator } from './RegexValidator'

//eslint-disable-next-line
export const CURRENCY_REGEX = /^\-?\d+(\.\d{1,2})?$/

export class CurrencyValidator extends RegexValidator {
    constructor() {
        super(CURRENCY_REGEX, 'validations.currency')
    }
}

export const CURRENCY_VALIDATOR = new CurrencyValidator()
